// @flow
import React, { PureComponent } from "react"
import { connect } from "react-redux"
import Alert from "@kiwicom/orbit-components/lib/Alert"

import { clearNotice as _clearNotice } from "common/services/notice"
import type { Notice as NoticeType } from "common/services/notice"
import { Container } from "./styles"

type Props = {
  notice: NoticeType,
  clearNotice: typeof _clearNotice,
}

class Notice extends PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    const { notice } = this.props

    if (notice !== prevProps.notice) {
      if (this.noticeTimeout) {
        clearTimeout(this.noticeTimeout)
      }

      if (notice && notice.ttl !== null) {
        this.noticeTimeout = setTimeout(this.handleClose, notice.ttl)
      }
    }
  }

  handleClose = () => {
    const { notice, clearNotice } = this.props

    if (!notice) {
      return
    }

    if (notice.onClose) {
      notice.onClose()
    }

    if (this.noticeTimeout) {
      clearTimeout(this.noticeTimeout)
    }

    clearNotice()
  }

  noticeTimeout: TimeoutID

  render() {
    const { notice } = this.props

    return (
      notice && (
        <Container>
          <Alert
            type={notice.type}
            icon={notice.icon}
            closable={notice.closable}
            onClose={this.handleClose}
            title={notice.title}
          >
            {notice.content}
          </Alert>
        </Container>
      )
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    notice: state.notice,
  }),
  {
    clearNotice: _clearNotice,
  },
)(Notice)
